'use strict';

var _enums = require('./enums');

var _enums2 = _interopRequireDefault(_enums);

var _price = require('./price');

var _iterateHalfHours = require('./iterateHalfHours');

var _iterateHalfHours2 = _interopRequireDefault(_iterateHalfHours);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _mongoose = require('mongoose');

var _mongoose2 = _interopRequireDefault(_mongoose);

var _Space = require('./schemas/Space');

var _Space2 = _interopRequireDefault(_Space);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// constants
var READABLE_DATE_FORMAT = 'YYYY-MM-DD';

// Number of bits in an int in the availability bitmap that are valid


// Lodash
var AVAILABILITY_NUM_BITS = 24;

// Time to allow flexibility (in hours, as a multiple of 100)
var FLEXIBILITY_MARGIN = 300;

var MAX_DURATION = 600;

/**
 * List of durations and associated times that you can start at.
 *
 * @param {Object} space as mongoose doc or POJO
 * @param {String} date YYYY-MM-DD
 * @param {Number} time HHmm
 * @param {Number} groupSize number of people to accommodate
 * @param {Boolean} [flexible] Optional, allow within 3 hours of suggested time
 * @return {Array} [{ duration: Number, times: [Number] }]
 */

exports.getAvailability = function (space, date, time, groupSize, flexible) {
  var maxDuration = MAX_DURATION;
  // Number of half-hour blocks
  var maxDurationBlocks = Math.floor(maxDuration / 30);
  var res = [];
  var isStrict = space.data.terms.extraHourPolicy === _enums2.default.extraHourPolicy.STRICT;

  var availableSlots = !(0, _lodash.isNumber)(time) ? space.data.timeSlots : (0, _lodash.filter)(space.data.timeSlots, function (slot) {
    var getTimeSlotMethod = flexible ? fitsTimeSlotFlexible : fitsTimeSlot;
    return getTimeSlotMethod(slot, date, time, null);
  });

  var needsFlexibility = !(0, _lodash.some)(space.data.timeSlots, function (slot) {
    return fitsTimeSlot(slot, date, time, null);
  });

  var selectedTime = time;
  (0, _lodash.each)(availableSlots, function (slot) {
    var slotTo = slot.to < slot.from ? slot.to + 2400 : slot.to;

    var slotLength = slotTo - slot.from;
    var slotLengthBlocks = Math.floor(slotLength / 30);

    // Incrementing length by 1 captures each 30 min increment
    for (var length = 2; length <= slotLengthBlocks && length <= maxDurationBlocks; length += 1) {
      var times = (0, _iterateHalfHours2.default)(slot.from, slotTo);

      var availableTimes = (0, _lodash.reject)(times, function (t) {
        if (needsFlexibility && flexible) {
          if (t < selectedTime - FLEXIBILITY_MARGIN || t > selectedTime + FLEXIBILITY_MARGIN) {
            return true;
          }
        }
        if (t + length * 30 / 60 * 100 > slotTo) {
          return true;
        }
      });

      if (availableTimes.length) {
        var durationIdx = (0, _lodash.findIndex)(res, function (availabilityObj) {
          return availabilityObj.duration === length * 30;
        });
        if (durationIdx !== -1) {
          res[durationIdx].times = _(res[durationIdx].times).concat(availableTimes).uniq().value().sort();
        } else {
          res.push({ duration: length * 30, times: availableTimes });
        }
      }
    }
  });
  return res;
};

/**
 * Helper function to programmatically display availability messages
 *
 * @param {spaceAvailability} return value from spaceAvailability.isAvailable
 * @return {String}
 */

exports.displayAvailability = function (spaceAvailability) {
  if (!spaceAvailability) {
    return;
  }
  var isAvailable = spaceAvailability.isAvailable;
  if (isAvailable) {
    return 'Available';
  }
  return spaceAvailability.reason;
};

/**
 * @param {Object} slot within `space.data.timeSlots`
 * @param {String} date YYYY-MM-DD
 * @param {Number} time HHmm Optional, if null, skip time check
 * @param {Number} [duration] Optional, in minutes
 * @return {Boolean} If the selected time can fit in the time slot
 */
function fitsTimeSlot(slot, date, time, duration) {
  date = _moment2.default.isMoment(date) ? date : _moment2.default.utc(date, 'YYYY-MM-DD');
  var dayOfWeek = date.day();
  if (!slot.days[dayOfWeek]) {
    return false;
  }
  if ((0, _lodash.isNumber)(time)) {
    // Correct time?
    /**
     * If slot.from < slot.to, the time slot crosses midnight.
     * For instance, 10:30AM => 1030, to 1:30AM => 130.
     * To counter this, slot.to = slot.to + 2400
     * This way, 10:30AM => 1030, to 1:30AM => 130+2400 = 2530
     * Not entirely sure if this makes sense...
    */
    var slotFrom = slot.from;
    var slotTo = slot.to;
    if (slotFrom > slotTo) {
      slotTo += 2400;
    }

    duration = duration ? duration : 100;

    if (time < slotFrom || time > slotTo) {
      return false;
    }
    if (time + duration < slotFrom || time + duration > slotTo) {
      return false;
    }
  }
  return true;
}

function fitsTimeSlotFlexible(slot, date, time, duration) {
  date = _moment2.default.isMoment(date) ? date : _moment2.default.utc(date);
  if (!slot.days[date.day()]) {
    return false;
  }
  if ((0, _lodash.isNumber)(time)) {
    // Correct time?
    /**
     * If slot.from < slot.to, the time slot crosses midnight.
     * For instance, 10:30AM => 1030, to 1:30AM => 130.
     * To counter this, slot.to = slot.to + 2400
     * This way, 10:30AM => 1030, to 1:30AM => 130+2400 = 2530
     * Not entirely sure if this makes sense...
    */
    var slotFrom = slot.from;
    var slotTo = slot.to;
    if (slotFrom > slotTo) {
      slotTo += 2400;
    }

    duration = duration ? duration : 100;

    if (time < slotFrom || time > slotTo) {
      if (time < slotFrom - FLEXIBILITY_MARGIN || time > slotTo + FLEXIBILITY_MARGIN) {
        return false;
      }
    }
    if (time + duration < slotFrom || time + duration > slotTo) {
      if (time + duration < slotFrom - FLEXIBILITY_MARGIN || time + duration > slotTo + FLEXIBILITY_MARGIN) {
        return false;
      }
    }
  }
  return true;
}
/**
 * Identify if a space is available based only on group size
 * @param {Object} space as mongoose doc of POJO
 * @param {Number} groupSize
 * @return {Object} with property availability and reason, if availability is false
 */

function groupSizeAvailability(groupSize, space) {
  var ret = { isAvailable: true };
  var min = Number.POSITIVE_INFINITY;
  var seatedMin = (0, _lodash.get)(space, 'data.capacity.seated.min');
  var standingMin = (0, _lodash.get)(space, 'data.capacity.standing.min');
  if (seatedMin && seatedMin < min) {
    min = seatedMin;
  }
  if (standingMin && standingMin < min) {
    min = standingMin;
  }

  var seatedMax = (0, _lodash.get)(space, 'data.capacity.seated.max');
  var standingMax = (0, _lodash.get)(space, 'data.capacity.standing.max');
  var max = 0;
  if (seatedMax && seatedMax > max) {
    max = seatedMax;
  }
  if (standingMax && standingMax > max) {
    max = standingMax;
  }

  if (groupSize < min) {
    ret.isAvailable = false;
    ret.reason = 'Group size too low';
    ret.threshold = min;
  } else if (groupSize > max) {
    ret.isAvailable = false;
    ret.reason = 'Group size too high';
    ret.threshold = max;
  }
  return ret;
}

exports.groupSizeAvailability = groupSizeAvailability;

/**
 * Find a time slot for the given date and time
 *
 * @param {Object} space as mongoose doc or POJO
 * @param {String} date YYYY-MM-DD
 * @param {Number} time HHmm Optional, if null, skip time check
 * @param {Number} [duration] Optional, in minutes
 * @param {Boolean} [flexible] Optional, return true for timeslots within 3 hours if possible
 * @return {Number} the index in the timeSlots array
 */

exports.getTimeSlot = function (space, date, time, duration, flexible) {
  var getTimeSlotMethod = flexible ? fitsTimeSlotFlexible : fitsTimeSlot;
  return (0, _lodash.findIndex)(space.data.timeSlots, function (slot) {
    return getTimeSlotMethod(slot, date, time, duration);
  });
};

exports.timeAvailability = function (space, date, time, duration, flexible) {
  var ret = {};
  var _duration = duration || 100;
  // Number of half-hour blocks

  var durationBlocks = Math.floor(_duration / 30);

  // Do we have a slot for this time?
  var index = exports.getTimeSlot(space, date, time, _duration, flexible);

  if (index === -1) {
    ret.isAvailable = false;
    ret.reason = time ? 'Not available for that date and time' : 'Not available on that date';
    return ret;
  }

  var slot = space.data.timeSlots[index];

  if (time == null) {
    // If time is not specified, take the slot's start time
    time = slot.from;
  }

  // -----------------------------
  // Is the next 30 minute block available?

  var dateFormatted = _moment2.default.isMoment(date) ? date.format(READABLE_DATE_FORMAT) : date;
  var str = dateFormatted + ' ' + Math.floor(time / 100) + ':' + time % 100;

  var dateWithTime = (0, _moment2.default)(str, READABLE_DATE_FORMAT + ' ' + 'H:m');
  var arrayOffset = (dateWithTime.dayOfYear() - 1) * 2 + (dateWithTime.hours() < 12 ? 0 : 1);
  var byteOffset = dateWithTime.hours() % 12 * 2 + (dateWithTime.minutes() >= 30 ? 1 : 0);

  var block = 0;
  while (block++ < durationBlocks) {
    var bitFlag = space.internal.availability[arrayOffset] & 1 << byteOffset;
    if (bitFlag !== 0) {
      ret.isAvailable = false;
      ret.reason = 'Not available at that time';
      return ret;
    }
    ++byteOffset;
    if (byteOffset > AVAILABILITY_NUM_BITS) {
      ++arrayOffset;
      byteOffset = 0;
    }
  }
  ret.isAvailable = true;
  ret.reason = null;
  if (flexible && time) {
    ret.suggested = time < slot.from || time > (slot.to < slot.from ? slot.to + 2400 : slot.to);
  }
  return ret;
};
/**
 * Can this space accommodate the given group size at the given date and time?
 * Currently doesn't distinguish between seated and standing.
 *
 * @param {Object} space as mongoose doc or POJO
 * @param {String} date YYYY-MM-DD
 * @param {Number} time HHmm, optional, if null, skips timecheck in getTimeSlot
 * @param {Number} groupSize, optional, if falsy, skips groupsize check
 * @param {Number} [duration] optional duration in minutes
 * @param {Boolean} [flexible] return true if a timeslot nearby is available
 * @return {Boolean}
 */

exports.isAvailable = function (space, date, time, groupSize, duration, flexible) {

  if (!space || !space.isVisible) {
    return { isAvailable: false, reason: 'This space is not visible' };
  }

  // Can we fit this group size?

  if (groupSize) {
    var availability = groupSizeAvailability(groupSize, space);
    if (!availability.isAvailable) {
      return availability;
    }
  }

  return exports.timeAvailability(space, date, time, duration, flexible);
};

/**
 * Return clone of space with price specific to a certain day and time based on an availability map
 * @param {Space} space
 * @param {AvailabilityMap} availabilityMap, SpaceAvailability object
 * @return {Space}
 */

exports.overridePrice = function (space, availabilityMap) {
  if (!availabilityMap) {
    return;
  }

  var clone = space;
  var id = clone._id.toString();
  var specificTimeSlotInfo = availabilityMap[id].data.availability.timeSlots;
  clone.data.timeSlots = (0, _lodash.each)(clone.data.timeSlots, function (slot) {
    var updatedSlot = (0, _lodash.find)(specificTimeSlotInfo, function (schedulerSlot) {
      return slot._id.toString() === schedulerSlot._id.toString();
    });
    if (updatedSlot) {

      var newMin = (0, _lodash.get)(updatedSlot, 'terms.foodBeverageMin');
      var newRoomFee = (0, _lodash.get)(updatedSlot, 'terms.roomFeeCents');
      var newExtraHourFee = (0, _lodash.get)(updatedSlot, 'terms.extraHourFee');

      if ((0, _lodash.isFinite)(newMin)) {
        (0, _lodash.set)(slot, 'terms.foodBeverageMin', newMin);
      }

      if ((0, _lodash.isFinite)(newRoomFee)) {
        (0, _lodash.set)(slot, 'terms.roomFeeCents', newRoomFee);
      }

      if ((0, _lodash.isFinite)(newExtraHourFee)) {
        (0, _lodash.set)(slot, 'terms.extraHourFee', newExtraHourFee);
      }
    }
    return slot;
  });
  return clone;
};

/**
 * Display Food and beverage minimum, excluding group size when calculating availability
 * @param {Space} space
 * @param {Moment|Date} date
 * @param {Array} spaces array in bookingRequest object
 */
exports.displayMin = function (space, date, spaces) {
  date = _moment2.default.isMoment(date) ? date : (0, _moment2.default)(date).utc();
  // find original, non-mutated space and clone it
  var theSpace = (0, _lodash.find)(spaces, function (originalSpace) {
    return originalSpace._id.toString() === space._id.toString();
  });

  var clone = theSpace.toObject ? theSpace.toObject() : (0, _lodash.cloneDeep)(theSpace);
  // filter timeSlots ONLY based on date, so we can get the correct price range even if group size is off
  clone.data.timeSlots = (0, _lodash.filter)(clone.data.timeSlots, function (slot) {
    return slot.days[date.day()];
  });

  return (0, _price.fbMinRangeDollars)(clone);
};

/**
 * Gets current availability from an array of availabilities and a request's duration
 *
 * @param {Array} Availabilities
 * @param {Request} request
 * @return {Array}
 */
exports.getCurrentAvailability = function (availabilities, request) {
  return (0, _lodash.find)(availabilities, function (v) {
    return v.duration === (0, _lodash.get)(request, 'data.duration');
  });
};

/**
 * Determine if a space has a timeslot with a given duration based on an availabilityMap
 *
 * @param {String} requestId
 * @param {Space} space
 * @param {Number} duration
 * @param {AvailabilityMap} availabilityMap
 * @return {Boolean}
 */
exports.hasAvailableSlot = function (requestId, space, duration, availabilityMap) {
  if (!space || !availabilityMap) {
    return;
  }
  var bucket = availabilityMap[space._id.toString()];
  var slots = (0, _lodash.get)(bucket, 'data.availability.timeSlots');
  if (!slots || !slots.length) {
    return false;
  }

  var notBookedAndLongEnough = (0, _lodash.some)(slots, function (slot) {
    return _isLongEnough(slot, duration);
  });
  return notBookedAndLongEnough;

  function _isLongEnough(slot, duration) {
    var bookingId = (0, _lodash.get)(slot, 'booking.requestId');
    if (slot.isBlocked || bookingId && bookingId !== requestId) {
      return false;
    }

    return (0, _lodash.isNumber)(duration) ? (slot.to < slot.from ? slot.to + 2400 : slot.to) - slot.from >= duration : true;
  }
};